import { SxProps } from '@mui/material';

export const sxCircleProgress = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
};

export const sxImageEditor = (isActive: boolean): SxProps => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  padding: isActive ? '25px' : 0,
  position: 'relative',
});
